@import '~style-sheet-helpers/core.less';
@import '../../../../constants/spacing.module.less';

.grid {
  margin: 0 0 @space-16;
  position: relative;
  background: var(--light--background-color--1);
  border: solid 1px var(--default--border-color--12);
  border-radius: @space-8;
  overflow: hidden;
}

.chart-toggle-link {
  display: flex;
  align-items: center;
  background: none;
  border: none;
  color: var(--blue-600);
  cursor: pointer;
  font-size: 14px;
  padding: 0;
  text-decoration: underline;

  &:hover {
    color: var(--blue-700);
  }

  &:focus {
    outline: 2px solid var(--blue-600);
    outline-offset: 2px;
  }
}

.grid-error,
.grid-empty {
  padding: @space-32 @space-24;
  text-align: center;
  color: var(--grey-600);
  background-color: var(--light--background-color--1);
}

.table-container {
  overflow-x: auto;
}

.table {
  width: 100%;
  border-collapse: collapse;

  &.react-table-wrapper {
    border: 1px solid var(--default--border-color--12);
    border-radius: @space-4;
    overflow: hidden;
  }
}

.numeric-cell {
  text-align: right;
  justify-content: flex-end;
}

.blurred-value {
  filter: blur(4px);
  user-select: none;
}

.quantity-input {
  width: 80px;
  text-align: right;
  padding: @space-4;
  border: 1px solid var(--table--border-color--2);
  border-radius: @space-4;
  height: 34px;

  &:focus {
    outline: 2px solid var(--blue-600);
    outline-offset: 0;
    border-color: var(--blue-600);
  }
}

.product-cell {
  display: flex;
  align-items: center;
  gap: @space-12;
}

.product-image {
  display: flex;
  justify-content: center;
  align-items: center;
}

.product-thumbnail {
  width: @space-32;
  height: @space-32;
  object-fit: contain;
  border-radius: @space-4;
  border: 1px solid var(--table--border-color--2);
}

.product-thumbnail-placeholder {
  width: @space-32;
  height: @space-32;
  background-color: var(--default--background-color--14);
  border-radius: @space-4;
  border: 1px solid var(--table--border-color--2);
}

.product-info {
  display: flex;
  flex-direction: column;
}

.product-name {
  font-size: var(--font-size-small, 14px);
  line-height: 21px;
}

.product-sku {
  font-size: var(--font-size-small, 12px);
  line-height: 18px;
  color: var(--grey-600);
}

.row--expanded {
  background-color: var(--grey-50);
}

.expanded-content {
  transition:
    max-height 0.3s ease-in-out,
    opacity 0.3s ease-in-out;
}
